































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Asl } from '@/data/models/asl.model';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Provincia } from '@/data/models/provincia.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Country } from '@/data/models/country.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class LuoghiEditModal extends Vue {
	@Prop() luogo!: Asl;

	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	provinciaClass: ClassType<Provincia> = Provincia;
	provincia: Provincia | null = null;

	@Inject('CrudService') countryCrudService!: CrudService<Provincia>;
	countryClass: ClassType<Country> = Country;
	country: Country | null = null;
	
	@Inject('CrudService') crudService!: CrudService<Asl>;

	constructor() {
		super();
	}

	mounted() {
		if(this.luogo.province) {
			this.provincia = new Provincia();
			this.provincia.descrizione = this.luogo.province;
		}
		if(this.luogo.country) {
			this.country = new Country();
			this.country.name = this.luogo.country;
		}
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.luogo.province = this.provincia.descrizione;
		}
	}

	onCountryChange() {
		if (this.country) {
			this.luogo.country = this.country.name;
			if(!this.country.isItalia) {
				this.provincia = new Provincia();
				this.luogo.province = undefined;
			}
		}
	}

	submit() {
		this.$emit('submit', this.luogo);
	}
}
